// src/components/Technology.js
import React from 'react';

const hexToRGBA = (hex, alpha) => {
  let h = hex.replace('#','');
  if (h.length === 3) {
    h = h.split('').map(c => c + c).join('');
  }
  const bigint = parseInt(h, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r},${g},${b},${alpha})`;
};

const TechCard = ({ name, icon, description, color }) => {
  const [hovered, setHovered] = React.useState(false);
  const [cursorPos, setCursorPos] = React.useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setCursorPos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  const containerStyle = {
    backgroundColor: hovered ? hexToRGBA(color, 0.2) : "#212121",
    transition: "background-color 0.3s",
    cursor: hovered ? "none" : "pointer",
  };

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
        setCursorPos({ x: 0, y: 0 });
      }}
      onMouseMove={handleMouseMove}
      style={containerStyle}
      className="relative border border-[#4d4d4d] rounded-md p-6 flex flex-col items-center overflow-hidden"
    >
      <img src={icon} alt={name} className="w-12 h-12 mb-2" />
      <span className="text-lg font-bold text-gray-300">{name}</span>
      <span className="text-sm text-gray-400">{description}</span>
      {hovered && (
        <div
          className="absolute pointer-events-none"
          style={{
            top: cursorPos.y,
            left: cursorPos.x,
            transform: "translate(-50%, -50%)",
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            backgroundColor: color,
            opacity: 0.8,
          }}
        ></div>
      )}
    </div>
  );
};

const Technology = () => {
  const techItems = [
    { id: 1, name: "React", icon: "../../vendor/react.svg", description: "UI Library", color: "#61DAFB" },
    { id: 2, name: "Figma", icon: "../../vendor/figma.svg", description: "Design Tool", color: "#F24E1E" },
    { id: 3, name: "Tailwind CSS", icon: "../../vendor/tailwindcss.svg", description: "Utility-First CSS", color: "#38B2AC" },
    { id: 4, name: "OpenWebUI", icon: "../../vendor/openwebui.svg", description: "UI Framework", color: "#8A2BE2" },
    { id: 5, name: "Ollama", icon: "../../vendor/ollama.svg", description: "LLM Framework", color: "#eae9f2" },
    { id: 6, name: "Node.js", icon: "../../vendor/nodejs.svg", description: "JS Runtime", color: "#3C873A" },
    { id: 7, name: "Github", icon: "../../vendor/github.svg", description: "Version Control", color: "#181717" },
    { id: 8, name: "Docker", icon: "../../vendor/docker.svg", description: "Containerization", color: "#2496ED" }
  ];

  return (
    <section
      id="technology"
      className="w-full bg-[#0d0d0d] flex flex-col items-center justify-center py-12 md:py-20"
    >
      <h2 className="text-3xl font-bold text-white text-center mb-4">Technology</h2>
      <p className="text-center text-gray-400 mb-8">Tools & technologies I work with</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 px-4">
        {techItems.map(item => (
          <TechCard
            key={item.id}
            name={item.name}
            icon={item.icon}
            description={item.description}
            color={item.color}
          />
        ))}
      </div>
    </section>
  );
};

export default Technology;